import React from 'react';
import firebase from './infocomponents/firebase';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';

function FootComponent() {
	return (
		<div>
			<footer className="footer bg-footer">
				<br />
				<br />
				<br />
				<Container>
					<Row className="justify-content-center">
						<Col>
							<h5 className="text-center slogan-1 text text-light ">Links</h5>
							<ul className="list-unstyled">
								<li className="text-center slogan-2">
									<Link to="/home" style={{ textDecoration: 'none' }} className="text-light">
										Home
									</Link>
								</li>

								<li className="text-center slogan-2">
									<Link to="/booking" style={{ textDecoration: 'none' }} className="text-light">
										Booking
									</Link>
								</li>
								<li className="text-center slogan-2">
									<Link to="/service" style={{ textDecoration: 'none' }} className="text-light">
										Service
									</Link>
								</li>
								<li className="text-center slogan-2">
									<Link to="/faq" style={{ textDecoration: 'none' }} className="text-light">
										Faq
									</Link>
								</li>
							</ul>
						</Col>
						<br />

						<Col md="4">
							<h5 className="text-center slogan-1 text-light">Our Stores</h5>
							<a href="https://g.page/cycleworx-in?share">
							<h4 className="text-center slogan-1 text-light">Delhi-Dwarka</h4>
							<address className="text-center slogan-2 text-light">
								<div>G-5,Vardhaman Plaza</div>
								<div>Dwarka Sector-10,Central Market</div>
								<div>Opp. Dwarka Sports Complex</div>
								<div>New Delhi-110075</div>
								<div>Mob: 8800195677</div>
								<div>Mob: 8882357173</div>
							</address>
							</a>
							< a href="https://goo.gl/maps/CuJeinQTaVKLHHb89">
							<h4 className="text-center slogan-1 text-light">Gurugram</h4>
							<address className="text-center slogan-2 text-light">
								<div>Shop-101,Sector-48</div>
								<div>Shriram Market, Sohna Road</div>
								<div>Adjacent to Shriram Dhaba</div>
								<div>Haryana-122018</div>
								<div>Mob: 8800195677</div>
							</address>
							</a>
							
							<a href="https://g.page/cycleworx-in-chandigarh?share"> <h4 className="text-center slogan-1 text-light">Chandigarh </h4>
							<address className="text-center slogan-2 text-light">
								<div>SCO: 204, Sector 7C</div>
								<div>Chandigarh-160019</div>
								<div>Mob: 9041166400</div>
							</address>
							</a>
						</Col>
						<Col md="4">
							<h5 className="text-center slogan-1 text-light">Contact us</h5>
							<address className="text-center slogan-2 text-light">
							<a href="//api.whatsapp.com/send?phone=918800195677&text=Hi I am reaching out through Web Utility" title="Click to Initiate WhatsApp Chat">
								<div>Tel / WhatsApp.: +91 8800195677</div>
							</a>
							<a href="//api.whatsapp.com/send?phone=919041166400&text=Hi I am reaching out through Web Utility" title="Click to Initiate WhatsApp Chat">
								<div>Tel / WhatsApp.: +91 9041166400 </div>
							</a>
								Email:{' '}
								<a href="mailto:support@fitom.in" className="text-light">
									support@fitom.in
								</a>
							</address>
						</Col>
					</Row>
				</Container>
				<br />
				<Container>
					<Row className="justify-content-center">
						<Col className="my-auto">
							<hr className="new4" />
						</Col>
					</Row>
				</Container>
				<Container fluid className="bg-copyright">
					<Row className="justify-content-center">
						<Col sm={6} className="pt-1">
							<p className="text-center text-light">© Copyright 2021 Fitom Technologies Private Limited</p>
						</Col>
					</Row>
				</Container>
			</footer>
		</div>
	);
}

export default FootComponent;
